import styled from "styled-components";
import media from "constants/media";

import Hero from "components/shared/hero/Hero";

export const HeroBanner = styled(Hero)`
    height: 245px;

    background-image: url("/images/helpdesk-letters-mobile.svg");
    background-repeat: no-repeat;
    background-position: center 127%;
    background-size: 775px;

    ${media.mdUp`
        height: 475px;

        background-image: url("/images/helpdesk-letters-desktop.svg");
        background-repeat: no-repeat;
        background-position: center 145%;
        background-size: 1900px;
    `}
`;

export const Content = styled.div`
    max-width: 580px;
    margin: 0 auto;
    padding: 30px 0;

    ${media.mdUp`
        padding: 45px 0 110px;
    `}
`;

export const Title = styled.h1`
    max-width: 260px;
    margin: 30px auto 22px;

    font-weight: normal;
    font-size: 35px;
    line-height: 40px;
    text-align: center;

    strong {
        font-weight: normal;
        font-family: var(--font-Agne);
    }

    ${media.mdUp`
        margin: 35px auto 42px;

        font-size: 64px;
        line-height: 70px;
        max-width: 580px;
    `}
`;

export const Search = styled.form`
    width: 100%;
    max-width: 320px;
    margin: auto;

    ${media.mdUp`
        max-width: 580px;
    `}
`;

export const SearchTitle = styled.h2`
    margin-bottom: 14px;

    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: left;

    ${media.mdUp`
        font-size: 16px;
        line-height: 25px;
        max-width: 580px;
    `}
`;
